<script setup lang="ts">
import Init from './components/Init.vue';
import TheGame from './components/TheGame.vue';
import Results from './components/Results.vue';
import useWordOfTheDayStore from './store';
import { storeToRefs } from 'pinia';
import ChalkBoardLayout from './layout/ChalkBoardLayout.vue';

const store = useWordOfTheDayStore();
const { gameState: state } = storeToRefs(store);
</script>

<template>
  <ChalkBoardLayout>
    <Init v-if="state === 'init'"></Init>
    <TheGame v-else-if="state === 'game' || state === 'game-over'"></TheGame>
    <Results v-else-if="state === 'results'"></Results>
  </ChalkBoardLayout>
</template>

<style scoped lang="scss">
@use 'vuetify/settings';

@font-face {
  font-family: 'Chalkduster';
  src: url('./assets/Chalkduster.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'Chalkduster', sans-serif;
}

:deep(.action-btn) {
  font-family: 'Comic Sans MS', sans-serif;

  @media screen and (min-width: 1440px) {
    font-size: 1.5rem !important;
  }
}
</style>
